import * as React from 'react';
import styled from 'styled-components';
import { useStore } from '../State';
import { isDisplayedInIframe } from './shared/styled/Theme';
import Header from './shared/Header';
import Footer from './shared/Footer';
import Media from './shared/styled/Media';
import SplashLayout from './SplashLayout';
import AppNotFound from './AppNotFound';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  ${({ theme }) =>
    isDisplayedInIframe(theme)
      ? `
    padding-top: 0;
  `
      : `
      @media ${Media.mobile} {
        padding-top: 3.75rem;
      }
      @media ${Media.tablet} {
        padding-top: 4.375rem;
      }`}
`;

const BodyContent = styled.div`
  flex: 1 1;
`;

type Props = {
  isReady: boolean;
  children: React.ReactNode;
};

const AppContent = ({ isReady, children }: Props) => {
  const { config } = useStore();
  return (
    <>
      <SplashLayout isBrandLoaded={isReady} />
      {isReady && (
        <>
          <Header />
          <Body>
            <BodyContent>
              {config.isNotValidMerchant() ? <AppNotFound /> : children}
            </BodyContent>
            {!config.isReturnPolicyMissing() && (
              <Footer policyUrl={config.getReturnPolicyUrl()} />
            )}
          </Body>
        </>
      )}
    </>
  );
};

export default AppContent;
